import React, { PropTypes } from 'react'
import CardMerger from '../Card/CardMerger'
import Paragraph from './Paragraph'

const CardMergerWrapper = ({ entity }) => {

  const flexProps = {}
  if (entity.colSmall) {
    flexProps.small = entity.colSmall
  }
  if (entity.colMedium) {
    flexProps.medium = entity.colMedium
  }
  if (entity.colLarge) {
    flexProps.large = entity.colLarge
  }

  return (
    <CardMerger>
      {entity.fieldItems.map(item => (
        <Paragraph key={item.entity.entityId} entity={item.entity} {...flexProps} />
      ))}
    </CardMerger>
  )
}

export default CardMergerWrapper
